// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btnCate_btn-cate__OHpDe {
  padding: 5px 15px;
  border-radius: 10px;
  font-size: 1.6rem;
  font-weight: 600;
  color: black;
}
.btnCate_btn-cate__OHpDe:hover {
  background-color: rgb(218, 220, 222) !important;
}

@media (max-width: 767px) {
  .btnCate_btn-cate__OHpDe {
    font-size: 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/content/category/btnCate.module.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AACJ;AACI;EACI,+CAAA;AACR;;AAEA;EACI;IACI,iBAAA;EACN;AACF","sourcesContent":[".btn-cate{\n    padding: 5px 15px;\n    border-radius:10px;\n    font-size: 1.6rem;\n    font-weight: 600;\n    color: black;\n\n    &:hover{\n        background-color: rgba(218,220,222,1) !important;\n    }\n}\n@media(max-width:767px){\n    .btn-cate{\n        font-size: 1.5rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn-cate": `btnCate_btn-cate__OHpDe`
};
export default ___CSS_LOADER_EXPORT___;
